import apiConfig from "../../apiConfig";

export const getTypeDetails = async (at, typeId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/Donations_Types/Get_Donation_Type_Details",
		{ Donation_Type_Id: typeId },
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response;
};
